import { adminFetch } from "./_client";
import type { PendingHostApprovalsResponse, PendingHostApprovalsSummary, PendingHostApprovalListParams, PendingHostApprovalNudgePayload, PendingHostApprovalNudgeResult, PendingHostApprovalBulkNudgeResult } from "./types";


export function fetchPendingHostApprovals(token: string, params: PendingHostApprovalListParams = {}) {
  const sp = new URLSearchParams();
  if (params.page) sp.set("page", String(params.page));
  if (params.pageSize) sp.set("pageSize", String(params.pageSize));
  if (params.risk && params.risk !== "all") sp.set("risk", params.risk);
  if (params.view) sp.set("view", params.view);
  if (params.q) sp.set("q", params.q);
  if (params.sort) {
    const [col, dir] = params.sort.split("_");
    sp.set("sort", `${col}:${dir}`);
  }
  const qs = sp.toString();
  return adminFetch<PendingHostApprovalsResponse>(`/admin/pending-host-approvals${qs ? `?${qs}` : ""}`, token);
}


export function fetchPendingHostApprovalsSummary(token: string) {
  return adminFetch<PendingHostApprovalsSummary>("/admin/pending-host-approvals/summary", token);
}


export function nudgePendingHostApproval(token: string, tripId: number, payload: PendingHostApprovalNudgePayload = {}) {
  return adminFetch<PendingHostApprovalNudgeResult>(`/admin/pending-host-approvals/${tripId}/nudge`, token, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}


export function bulkNudgePendingHostApprovals(
  token: string,
  tripIds: number[],
  payload: PendingHostApprovalNudgePayload = {},
) {
  return adminFetch<PendingHostApprovalBulkNudgeResult>(`/admin/pending-host-approvals/bulk-nudge`, token, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...payload, tripIds }),
  });
}


export function cancelPendingHostApproval(token: string, tripId: number, reason?: string) {
  return adminFetch<{ ok: true }>(`/admin/pending-host-approvals/${tripId}/cancel`, token, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reason: reason ?? "" }),
  });
}
